<template>
  <div class="product-tile-wrapper" :bd-thc="item.thc_cbd_levels ? item.thc_cbd_levels.thc_level : ''" :bd-cbd="item.thc_cbd_levels ? item.thc_cbd_levels.cbd_level : ''" :bd-brand="(item.brand && item.brand.name ? item.brand.name : '')" :bd-plant-type="(item.cannabis_attributes && item.cannabis_attributes.plant_type) ?  item.cannabis_attributes.plant_type : ''">
    <div class="product-item-card weed-card">
      <div class="product-card-header body-text-dark" ref="header_box">
        <div :class="'relative' + (isGuest == false ? ' pr-25px' : '') ">
          <h4 class="card-product-title has-text-weight-semibold max-3-line pointer" @click.prevent="callback(item)">{{ item.name }}</h4>
          <CardFavIcon :product="item"/>
        </div>
       <div>
          <p v-if="item.brand && item.brand.name && (item.brand.name != 'No Brand')" class="is-size-11 has-text-weight-semibold is-uppercase letter-space-1">{{ item.brand.name }}</p>
        </div>
      </div>

      <div class="product-card-body" ref="body_box" ><!-- :style="'height:calc(100% - '+cardImageHeight+'px)'" -->
        <div :class="'product-weed-left body-text-dark pointer relative ' + (item.variants.length > 1 ? 'multiple' : 'single')"  @click.prevent="callback(item)">
          <span v-if="itemOnSale" class="single-sale-tag is-size-11 has-text-weight-semibold"> {{ itemOnSalePercentage }}</span>
          <img v-if="item.image" :src="item.image+'?d=200x200'" :alt="item.name" />
          <img v-else src="@/assets/img/leaf.png" :alt="item.name" />
        </div>
        <div class="product-weed-right">
          <p class="is-size-14 text-primary has-text-weight-semibold letter-space-1 is-capitalized">{{ (item.cannabis_attributes && item.cannabis_attributes.plant_type) ?  item.cannabis_attributes.plant_type : ''}}</p>
          <div class="body-text-dark">
            <div class="weed-thc-level" v-if="thc">
              <div>
                <p class="is-size-12px">THC</p>
                <p class="is-size-12px has-text-weight-semibold">{{ thc }}</p>
                <div :class="'weed-thc-indicator ' + (item.thc_cbd_levels ? item.thc_cbd_levels.thc_level : '')"><span></span><span></span><span></span></div>
              </div>
            </div>
            <div class="weed-cbd-level is-flex-column is-flex" v-if="cbd">
              <div>
                <p class="is-size-12px">CBD</p>
                <p class="is-size-12px has-text-weight-semibold">{{ cbd }}</p>
                <div :class="'weed-thc-indicator ' + (item.thc_cbd_levels ? item.thc_cbd_levels.cbd_level : '')"><span></span><span></span><span></span></div>
              </div>
            </div>
          </div>  
        </div>
      </div>

      <div class="product-card-footer border-top-none" ref="footer_box">
          <!-- for only 1 variant available -->
        <div class="action-for-single-variant body-text-dark justify-content-between full-width is-flex is-flex-column" v-if="variants.length == 1">
          <div class="single-variant is-flex align-items-center justify-content-between">
            <p class="is-size-16px">{{ variants[0].size }}</p>
            <p class="has-text-weight-semibold is-size-22px">${{ firstItemPrice }}</p>  
          </div>
          <a @click.prevent="addToCart()" class="is-height-44 full-width button add-to-cart is-size-6 has-text-weight-semibold letter-space-1 is-fixed-add-to-cart">ADD TO STASH</a>
        </div>
        <!-- for multiple variant available -->
        <div class="action-for-multiple-variant justify-content-between full-width is-flex is-flex-column" v-else>
          <!--<div class="single-variant is-flex align-items-center body-text-dark justify-content-end">
             <p class="">Starting from <span class="has-text-weight-semibold is-size-5">${{ variantItemPrice }}</span></p>  
          </div> -->

            <SelectVariant
              :options="variants"
              :placeholdertext="`${variants.length} variants from <span class='is-size-22px has-text-weight-semibold has-text-dark'>$${firstItemPrice}</span>`"
              :callback="onSelectVariant"
          />

          <a @click.prevent="addToCart()" v-if="selectedVariant.id" class="is-height-44 letter-space-1 full-width button add-to-cart is-size-6 has-text-weight-semibold is-fixed-add-to-cart">ADD TO STASH</a>
          <a v-else class="is-height-44 full-width button letter-space-1 is-size-6 has-text-weight-semibold is-fixed-add-to-cart-ouline pointer-none">CHOOSE ONE</a>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Helpers from '@/Components/Helpers/Helpers';
import SelectVariant from "@/Components/Pages/Helpers/SelectVariant.vue";
import Env from "@/env";
import CartApis from '@/Components/Controllers/CartApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import ProductApis from '@/Components/Controllers/ProductApis';
import { mapGetters, mapActions} from 'vuex';
import CardFavIcon from '@/Components/Pages/PageComponents/StoreProfile/CardFavIcon.vue';

export default {
  components: {
    SelectVariant,
    CardFavIcon
  },
  data() {
    return {
      productDetail: {},
      itemOnSale: false,
      itemOnSalePercentage: false,
      totalNumberOfAddableVariants: 0,
      selectedVariant:{
      },
      // cardImageHeight: 0,
      qty: 1,
    };
  },
  props: {
    item: Object,
    callback: {
      type: Function,
      required: true,
    },
  },
  computed: {

    /**
     * If kiosk or user not logged in do not show the fav button
     */
     isGuest() {
      if(this.vg_userId){
        return this.$route.query['kiosk'] ? true : false;
      }
      return true;
    },
    ...mapGetters({
      vg_userId: "getLoggedInUserId",
      vg_cartId: 'cart/id',
      vg_cartItems: "cart/cartItems",
      vg_cartItemsIds: "cart/cartItemsIds",
      vg_selectedStore: "location/selected",
      vg_cannabisLimit: "location/cannabis_limit",
      vg_weightOnCart: "cart/cartWeight",
      vg_favProducts: "favouriteproducts/list",
      vg_guestLandedQueries: "location/guestLandedQueries",
    }),

    variants() {
      // First create unique variant , only for cannabis
      return  Helpers.getUniqueProductVariants(this.item.product_family, this.item.variants);
    },

    thc() {
      return Helpers.getTHCValue(this.item);
    },
    cbd() {
      return Helpers.getCBDValue(this.item);
    },

    variantItemPrice() {
      if(_.isEmpty(this.selectedVariant)) {
        return this.firstItemPrice; // first item price
      } 
      if(this.selectedVariant.sale_price && (this.selectedVariant.sale_price < this.selectedVariant.price)){
        return this.selectedVariant.sale_price.toFixed(2);
      }
      return this.selectedVariant.price.toFixed(2);
    },

    firstItemPrice() {
      // Check first variant to figure out the price and sale 
      if(this.variants[0] && this.variants[0].price){
        if(this.variants[0].sale_price && this.variants[0].sale_price < this.variants[0].price){
          this.itemOnSale = true;
          let salePercentData = ((this.variants[0].price-this.variants[0].sale_price) / this.variants[0].price)*100;
          this.itemOnSalePercentage = ((salePercentData - Math.floor(salePercentData)) ? salePercentData.toFixed(0) : salePercentData) + '% OFF';
          return (this.variants[0].sale_price).toFixed(2);
        }
        this.itemOnSale = false;
        return (this.variants[0].price).toFixed(2);
      } 
      this.itemOnSale = false;
      return 0;
    },

  },

  async mounted() {
    this.va_spinner(false);
    this.totalNumberOfAddableVariants = await Helpers.getTotalNumberOfAddableVariants(this.variants);
    // if(this.totalNumberOfAddableVariants == 1){
    //   // if the available variant is only 1 make it auto selected
    //   this.selectedVariant =  Helpers.getFirstAvailableVariant(this.item.variants);
    // }

    if(this.variants.length == 1){
      this.selectedVariant = this.variants[0];
    }
  
  },

  destroyed() {
   
  },

  methods: {

    onSelectVariant(e){
      this.selectedVariant = e;
    },

    ucfirst(value) {
      return _.startCase(_.toLower(value));
    },

    /**
     * Add to cart
     */
    async addToCart() {
      // Fetch the product detail because the list api doesnot have full data
      this.va_spinner(true);
      let res = await ProductApis.fetchById(this.item.id);
      if(res.status != 200){
      return this.va_snackbar({
        type: 'warning', 
        message: 'Sorry error getting product detail.',
      });
      }
      this.productDetail = res.data.payload;

       // If we dont have cart id create cart first 
      if(this.vg_cartId == ''){
        await CartApis.createCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));
      }
      // threshold 
      if(this.totalNumberOfAddableVariants < 1){
        this.va_spinner(false);
        return this.va_snackbar({
          type: 'warning', 
          message: 'Products variants are not available.',
        });
      }
  
       // Check if variant is selected 
      if( _.isEmpty(this.selectedVariant) ) {
        this.va_spinner(false);
        return this.va_snackbar({
          type: 'warning', 
          message: 'Please Select Weight & Price.',
        });
      }

      // If already exceed limit
      if( parseFloat(this.vg_weightOnCart) > parseFloat(this.vg_cannabisLimit) ){
        this.va_spinner(false);
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: this.vg_weightOnCart,
          modal: true,
        });
        return false;
      }

      // If going to exceed limit on adding this item, no qty now this.qty *
      let currentProductWeight =  parseFloat(this.selectedVariant.weight_equivalent_dry_cannabis);
      let finalWeight = parseFloat(currentProductWeight) + parseFloat(this.vg_weightOnCart);

      if(finalWeight > parseFloat(this.vg_cannabisLimit) ) {
        this.va_spinner(false);
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: finalWeight,
          modal: true,
        });
        return false;
      }

      let checkExistingProduct = _.find(this.vg_cartItems, { location_product_id: parseInt(this.productDetail.id), location_product_variant_id: parseInt(this.selectedVariant.id) });
      if(checkExistingProduct == undefined){
        // validate if we have instock, at least one item is always avaibale , this doesnot have qty select
        if(parseInt(this.qty) > parseInt(this.selectedVariant.no_of_units - this.selectedVariant.inventory_threshold) ){
          // reject cannot add qty more than no of units
          this.va_spinner(false);
          return this.va_snackbar({
            message: Env.errorMessages.exceed_stock_limit,
            type: 'error',
          });
        } 

        let addedProduct =  await this.addCartItem();
        if(addedProduct){
          let recommendProductsRes = await ProductApis.fetchRecommendProductsByLocationProductIds({
            location_products_ids: this.vg_cartItemsIds
          }) 
          if(recommendProductsRes.status == 200){
            let collectrecommendProducts = Helpers.collectRecommendProducts(recommendProductsRes.data.payload);
            if(collectrecommendProducts.length > 0){
              bus.$emit('added-to-cart-recommend-products', {
                modal: true,
                addedProduct: addedProduct,
                recommendProducts: collectrecommendProducts
              })
            }
          }
        }
        this.va_spinner(false);
      } else {
        // Now before update lets check no of qty he can add
        let existingProductQty = checkExistingProduct.unit;
        // let maxCanBeAdded = parseInt(this.selectedVariant.no_of_units) - parseInt(existingProductQty);
        let maxCanBeAdded = parseInt(this.selectedVariant.no_of_units - this.selectedVariant.inventory_threshold) - parseInt(existingProductQty);

        if(parseInt(this.qty) > maxCanBeAdded){
          // reject cannot add qty more than no of units
          this.va_spinner(false);
          return this.va_snackbar({
            message: Env.errorMessages.exceed_stock_limit,
            type: 'error',
          });
        } 
        await this.updateCartItem(checkExistingProduct);

      }
    },

    /**
     * Add cart item
     */
    async addCartItem() {
      let obj = {
        user_id: this.$store.getters.getLoggedInUserId,
        location_id: this.vg_selectedStore.id,
        cart_id: this.vg_cartId == '' ? 'Not available' : this.vg_cartId,
        location_product_id: this.productDetail.id,
        category_id: this.productDetail.category_id ? this.productDetail.category_id : null,
        category_name: this.productDetail.category ? this.productDetail.category.name : null,
        thc_cbd_value_type: this.productDetail.category ? this.productDetail.category.thc_cbd_value_type : '',
        product_name: this.productDetail.name,
        product_family: this.productDetail.product_family,
        product_id: this.productDetail.id,
        product_image: this.productDetail.image ? this.productDetail.image : 'http://unohop.dev.unoapp.io/img/leaf.47bfc5db.png',
        product_type: this.productDetail.product_type ? this.productDetail.product_type : '',
        brand_name: this.productDetail.brand ? this.productDetail.brand.name : '',
        location_product_variant_id: this.selectedVariant.id,
        location_variant_sku: this.selectedVariant.sku,
        location_product_variant_external_sku: this.selectedVariant.external_id,
        price: parseFloat(this.selectedVariant.sale_price) > 0 && parseFloat(this.selectedVariant.sale_price) < parseFloat(this.selectedVariant.price) ? this.selectedVariant.sale_price : this.selectedVariant.price, // if has sale price & sale must be lower than regular, then use sale else regular price
        actual_price: this.selectedVariant.price,
        weight: this.selectedVariant.weight_equivalent_dry_cannabis ? this.selectedVariant.weight_equivalent_dry_cannabis : 0,
        unit: 1,
        app_version: Env.appVersion,
        platform: Env.appPlatform,
        //product: this.productDetail, // triple to match fav style
        selected_variant: this.selectedVariant,        
        weighing_unit: this.productDetail.weighing_unit ? this.productDetail.weighing_unit : 'null',
      }

      // Add THC,CBD,cannabis attributes only if family is cannabis
      if(this.productDetail.product_family == 'cannabis'){
        obj.cannabis_attributes = this.productDetail.cannabis_attributes ? Helpers.unsetKeyFromObj(['createdAt', 'updatedAt', 'created_at', 'updated_at'], this.productDetail.cannabis_attributes) : {};
        obj.thc_cbd_levels = this.productDetail.thc_cbd_levels ? Helpers.unsetKeyFromObj(['created_by', 'createdAt', 'updated_by', 'updatedAt', 'created_at', 'updated_at'], this.productDetail.thc_cbd_levels) : {};
      }

      let res = await CartApis.add(obj, this);
      if(res.status == 200) {
       
        // we get cart id here assign it
        this.va_setCartId(res.data.payload.id);
        this.va_setCartDetail(res.data.payload);
        if(this.$store.getters.getLoggedInUserId){
          // Description is not allowed on add to cart so add once its done for vbout
          //  obj.description = this.productDetail.description; not any more
          // lets save the data on vbout
          VboutApis.addCartItem(obj, Helpers.getLocationProductFullUrl(this, obj.product_id), this.vg_selectedStore.id);
        }
       
        // G tracking add to cart
        this.$gtag.event('add_to_cart', { 
          items: [
            {
              id: this.productDetail.id,
              name: this.productDetail.name, 
              brand: this.productDetail.brand ? this.productDetail.brand.name : null,
              category: this.productDetail.category ? this.productDetail.category.name : null,
              variant: this.selectedVariant.size ? this.selectedVariant.size : null,
              quantity: parseInt(this.qty),
              price: parseFloat(this.selectedVariant.sale_price) > 0 && parseFloat(this.selectedVariant.sale_price) < parseFloat(this.selectedVariant.price) ? this.selectedVariant.sale_price : this.selectedVariant.price,
            }
          ]
        });
        if(!this.$store.getters.getLoggedInUserId){
          // If guest user else pubnub will throw
          this.va_snackbar({
            message: res.data.msg,
            type: 'success',
          });
        }
        return obj;
      } else {
        this.va_snackbar({
          message: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
          type: res.status == 200 ? 'success' : 'error',
        });
        return false;
      }
 
    },

     /**
     * Update cart item
     */
    async updateCartItem(item) {
      this.va_spinner(true);
      //Clone the object and filter
      var obj = _.clone(item);
      obj.cart_item_id = item.id;
      obj.unit = parseInt(item.unit) + parseInt(1);
      obj.app_version = Env.appVersion;
      obj.platform = Env.appPlatform;
      let res = await CartApis.update(obj);
      this.va_spinner(false);
      if(res.status == 200) {
        if(this.$store.getters.getLoggedInUserId == false){
          // If guest user 
          this.va_snackbar({
            message: res.data.msg,
            type: 'success',
          });
        } else {
         // For vbout only push current added because its add api not update api
          obj.unit = parseInt(this.qty);
          VboutApis.addCartItem(obj, Helpers.getLocationProductFullUrl(this, obj.product_id), this.vg_selectedStore.id);
        }
        return true;
      } 
      this.va_snackbar({
        message: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        type: res.response.status == 200 ? 'success' : 'error',
      });
      return false;
    },

    ...mapActions({
      va_setCartId: "cart/setId",
      va_setCartDetail: "cart/setCartDetail",
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
    })

  }
};
</script>
